<!--
 * @Author: Tahiti
 * @Date: 2025-10-20 13:34:19
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-12 18:44:33
 * @Description: 
 * @FilePath: /weryai-web/components/AppHeader.vue
-->
<template>
    <div
        class="sticky top-0 z-50 w-full bg-[var(--el-menu-bg-color)] h-[52px] border-b border-b-third-default text-white">
        <header class="flex items-center justify-between h-full md:px-5 px-2">
            <!-- Logo  -->
            <div class="flex items-center md:gap-4 gap-1">
                <div v-if="appStore.isSmallScreen" class="flex items-center flex-shrink-0">
                    <button type="button"
                        class="text-white hover:bg-gray-700 rounded-lg p-2 transition-colors duration-200" @click="
                            appStore.setToolSidebarOpen(
                                !appStore.toolSidebarOpen
                            )
                            ">
                        <img v-if="!appStore.toolSidebarOpen" src="/assets/images/common/menu.svg" alt="menu"
                            class="w-6 h-6" />
                        <img v-else src="/assets/images/common/_close.webp" alt="menu" class="w-6 h-6" />
                    </button>
                </div>

                <img v-if="!showHistoryProjectHeader"
                    src="https://static.weryai.com/growth/image/weryai_5cb7d93ce37f69e6825b5bf4396a3d12.png" alt="logo"
                    class="cursor-pointer w-[103px] md:w-[129px]" @click="backToWebsite" />
            </div>

            <div class="flex items-center md:gap-4 gap-1">
                <template v-if="showHistoryProjectHeader">
                    <HistoryProjectSelector />
                </template>
                <template v-else>
                    <!-- 多语言切换器 (已隐藏) -->
                    <div v-if="false" class="language-switcher">
                        <div v-if="getCurrentLanguageName()" ref="languageDropdownRef" class="relative"
                            @mouseenter="openLanguageDropdown" @mouseleave="closeLanguageDropdown">
                            <button class="language-button">
                                {{ getCurrentLanguageName() }}
                                <svg class="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>

                            <Transition enter-active-class="transition-all duration-200 ease-out"
                                enter-from-class="opacity-0 transform -translate-y-2 scale-95"
                                enter-to-class="opacity-100 transform translate-y-0 scale-100"
                                leave-active-class="transition-all duration-150 ease-in"
                                leave-from-class="opacity-100 transform translate-y-0 scale-100"
                                leave-to-class="opacity-0 transform -translate-y-2 scale-95">
                                <div v-if="isLanguageDropdownOpen"
                                    class="absolute left-0 top-full min-w-[320px] bg-setting-bg rounded-lg shadow-lg border border-gray-700 z-50"
                                    style="margin-top: 2px">
                                    <div class="p-2 grid grid-cols-2 gap-x-1">
                                        <button v-for="lang in availableLanguages" :key="lang.code"
                                            class="px-3 py-2 text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center justify-start whitespace-nowrap"
                                            :class="{
                                                '!text-text-active':
                                                    locale === lang.code,
                                            }" @click="handleLanguageChange(lang.code)">
                                            <span>{{ lang.name }}</span>
                                        </button>
                                    </div>
                                </div>
                            </Transition>
                        </div>
                    </div>

                    <div v-if="!userInfo && LOGIN_ENTRY_ENABLED" aria-label="User Login Button" tabindex="0" role="button" class="user-profile"
                        @click="() => showLoginModal()">
                        <div class="user-profile-inner">
                            <p class="text-white text-lg">
                                {{ t('menus.login') }}
                            </p>
                        </div>
                    </div>

                    <!-- user info -->
                    <div v-if="userInfo" class="flex items-center gap-2">
                        <div class="flex items-center coin balance" @click="handleCoinClickToPageJump">
                            <img src="~/assets/images/common/coin.webp" alt="credit" class="w-4 h-4 mr-1" />
                            <span class="text-white text-xs">
                                {{ balance }}
                            </span>
                        </div>
                        <div ref="dropdownRef" class="relative" @mouseenter="openDropdown" @mouseleave="closeDropdown">
                            <div class="flex items-center gap-1 cursor-pointer p-1 transition-colors duration-200">
                                <img v-if="userInfo?.avatar" :src="userInfo?.avatar" alt="user-avatar"
                                    class="w-8 h-8 rounded-full" />
                                <div class="text-sm text-white max-w-[100px] truncate">
                                    {{ userInfo?.nick_name }}
                                </div>
                                <svg class="w-4 h-4 text-white transition-transform duration-200 ease-in-out"
                                    :class="{ 'rotate-180': isDropdownOpen }" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>

                            <Transition enter-active-class="transition-all duration-200 ease-out"
                                enter-from-class="opacity-0 transform -translate-y-2 scale-95"
                                enter-to-class="opacity-100 transform translate-y-0 scale-100"
                                leave-active-class="transition-all duration-150 ease-in"
                                leave-from-class="opacity-100 transform translate-y-0 scale-100"
                                leave-to-class="opacity-0 transform -translate-y-2 scale-95">
                                <div v-if="isDropdownOpen"
                                    class="absolute right-0 top-full min-w-36 bg-setting-bg rounded-lg shadow-lg border border-gray-700 z-50"
                                    style="margin-top: 2px">
                                    <div class="p-2">
                                        <button
                                            class="w-full menu-balance hidden whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 items-center gap-2"
                                            @click="handleCoinClickToPageJump">
                                            <img src="~/assets/images/common/coin.webp" alt="credit" class="w-4 h-4" />
                                            <span>
                                                {{ balance }}
                                            </span>
                                        </button>
                                        <button @click.stop="handleMenuClick('profile')"
                                            class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                            <el-icon class="!text-base">
                                                <User />
                                            </el-icon>
                                            {{ t('menus.profile') }}
                                        </button>
                                        <button @click.stop="handleMenuClick('billing')"
                                            class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"
                                                aria-hidden="true">
                                                <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                                                <line x1="2" x2="22" y1="10" y2="10"></line>
                                            </svg>
                                            {{ t('menus.billing') }}
                                        </button>
                                        <button
                                            class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-red-500 hover:text-text-active transition-colors duration-200 flex items-center gap-2"
                                            @click.stop="handleMenuClick('logout')">
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                                                </path>
                                            </svg>
                                            <span>
                                                <span>
                                                    {{ t('menus.logout') }}
                                                </span>
                                                <span class="ml-1">(v{{ version }})</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </Transition>
                        </div>
                    </div>
                </template>
            </div>
        </header>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { User } from '@element-plus/icons-vue'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'
import { useI18n } from '@/composables/useI18n'
import { showLoginModal } from '@/utils/emitter'
import { availableLanguages } from '@/utils/common'
import { navigateTo } from '#app'
import HistoryProjectSelector from '@/components/HistoryProjectSelector.vue'
import { LOGIN_ENTRY_ENABLED } from '@/utils/feature-flags'

const config = useRuntimeConfig()
const version = config.public.appVersion

// 使用 Pinia store 管理全局状态
const appStore = useAppStore()
const userStore = useUserStore()
const { t, changeLanguage, locale } = useI18n()
const route = useRoute()

// ====== history mobile header switch ======
const getCurrentPathname = () => {
    return import.meta.client && typeof window !== 'undefined'
        ? window.location.pathname
        : route.path || '/'
}

const showHistoryProjectHeader = computed(() => {
    // Important: ensure this computed depends on the reactive route,
    // otherwise SPA navigation won't trigger recomputation.
    // (We still prefer pathname for language prefix aliases.)
    const _routePath = route.path
    const p = getCurrentPathname()
    const isHistory = /^\/(?:[a-z]{2}\/)?history(?:\/|$)/.test(p)
    return appStore.isSmallScreen && isHistory
})

// 下拉菜单状态
const isDropdownOpen = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)
let closeTimer: ReturnType<typeof setTimeout> | null = null

// 语言切换器状态
const isLanguageDropdownOpen = ref(false)
const languageDropdownRef = ref<HTMLElement | null>(null)
let languageCloseTimer: ReturnType<typeof setTimeout> | null = null

const balance = computed(() => userStore.balance || 0)
const userInfo = computed(() => userStore.userInfo)

// 获取当前语言名称
const getCurrentLanguageName = () => {
    const currentLang = availableLanguages.find(
        lang => lang.code === locale.value
    )
    return currentLang ? currentLang.name : ''
}

/**
 * 计算“当前 URL 语言模式”的基础前缀
 * - /en/... => /en
 * - /ja/... => /ja
 * - 无前缀英文 => ''
 *
 * 注意：/en 通过 alias 实现，route.path 可能丢失 /en 前缀，所以优先取地址栏 pathname。
 */
const getUrlBasePrefix = () => {
    const supported = [
        'zh',
        'en',
        'ja',
        'ko',
        'tw',
        'es',
        'fr',
        'de',
        'ru',
        'pl',
        'pt',
        'it',
        'ar',
    ]
    const p =
        import.meta.client && typeof window !== 'undefined'
            ? window.location.pathname
            : route.path || '/'
    const m = p.match(/^\/([a-z]{2})(\/|$)/)
    const maybe = m?.[1]
    if (maybe && supported.includes(maybe)) {
        return maybe === 'en' ? '/en' : `/${maybe}`
    }
    return ''
}

const withUrlPrefix = (toPath: string) => {
    const base = getUrlBasePrefix()
    if (!base) return toPath
    if (toPath === '/') return base
    return `${base}${toPath}`
}

const backToWebsite = () => {
    navigateTo(withUrlPrefix('/'))
}

// 打开下拉菜单
const openDropdown = () => {
    // 清除关闭定时器
    if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
    }
    isDropdownOpen.value = true
}

// 关闭下拉菜单
const closeDropdown = () => {
    // 延迟关闭，给用户时间移动到下拉菜单
    closeTimer = setTimeout(() => {
        isDropdownOpen.value = false
        closeTimer = null
    }, 200)
}

// 打开语言下拉菜单
const openLanguageDropdown = () => {
    // 清除关闭定时器
    if (languageCloseTimer) {
        clearTimeout(languageCloseTimer)
        languageCloseTimer = null
    }
    isLanguageDropdownOpen.value = true
}

// 关闭语言下拉菜单
const closeLanguageDropdown = () => {
    // 延迟关闭，给用户时间移动到下拉菜单
    languageCloseTimer = setTimeout(() => {
        isLanguageDropdownOpen.value = false
        languageCloseTimer = null
    }, 200)
}

// 语言切换处理
const handleLanguageChange = (langCode: string) => {
    changeLanguage(langCode)
    isLanguageDropdownOpen.value = false
}

// 菜单项点击处理
const handleMenuClick = (action: string) => {
    // 立即关闭下拉菜单
    if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
    }
    isDropdownOpen.value = false

    if (action === 'logout') {
        userStore.logout()
        appStore.clearRecentCreatedOrder()
        // 使用 window.location 强制刷新页面以确保跳转成功
        window.location.href = withUrlPrefix('/')
        return
    } else if (action === 'profile') {
        emitter.emit('open-user-profile-modal')
    } else {
        // 使用 window.location 强制跳转到目标页面
        window.location.href = withUrlPrefix('/' + action)
    }
}

// 页面跳转
const handleCoinClickToPageJump = () => {
    if (balance.value == 0) {
        // 余额为0，跳转到 pricing 页面并显示按年计费
        navigateTo('/pricing?tab=yearly')
    } else {
        // 有余额，跳转到 pricing 页面并显示按积分收费
        navigateTo('/pricing?tab=credits')
    }
}
</script>

<style scoped>
.coin {
    user-select: none;
    cursor: pointer;
}

/* 导航链接样式 */
.nav-link {
    @apply text-white text-sm font-medium px-3 py-2 rounded-lg transition-colors duration-200 hover:text-text-active hover:bg-gray-700/50 flex items-center;
}

/* 下拉菜单样式 */
.nav-dropdown {
    @apply relative;
}

.nav-dropdown:hover .dropdown-menu {
    @apply opacity-100 visible translate-y-0;
}

.dropdown-menu {
    @apply absolute top-full left-1/2 transform -translate-x-1/2 translate-y-2 bg-gray-800 rounded-lg shadow-lg border border-gray-700 opacity-0 invisible transition-all duration-200 ease-out z-50;
    min-width: 200px;
}

.dropdown-content {
    @apply p-2;
}

.dropdown-item {
    @apply block w-full px-4 py-2 text-sm text-white hover:text-blue-400 hover:bg-gray-700/50 rounded-md transition-colors duration-200;
}

/* 按钮样式 */
.btn-primary {
    @apply bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-2 rounded-lg font-medium transition-all duration-200 hover:from-blue-600 hover:to-purple-700 hover:shadow-lg;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .nav-dropdown .dropdown-menu {
        @apply left-0 transform-none;
    }
}
</style>

<style>
/* 语言切换器样式 */
.language-switcher {
    @apply relative;
}

.language-button {
    @apply flex whitespace-nowrap items-center px-3 py-2 text-sm text-white hover:text-text-active rounded-lg transition-colors duration-300;
}

.language-switcher:hover .absolute {
    @apply opacity-100 visible translate-y-0;
}

/* 极小屏幕优化：保证关闭按钮不被挤压（< 430px） */
@media (max-width: 430px) {
    .balance {
        display: none;
    }

    .menu-balance {
        display: flex;
    }
}

/* 移动端优化：多语言按钮去掉 padding */
@media (max-width: 768px) {
    .language-button {
        padding-left: 0;
        padding-right: 0;
    }
}

/* 移动端优化：登录按钮缩小占位 */
@media (max-width: 768px) {
    .user-profile {
        width: 92px;
        height: 36px;
        transform: none;
        border-radius: 10px;
    }

    .user-profile-inner {
        width: 89px;
        height: 33px;
        border-radius: 9px;
    }

    .user-profile-inner p {
        font-size: 13px;
    }
}
</style>
